// Shared so every input/select/autocomplete inside the test creatives filter
// bar resolves to the same MUI size (and therefore the same height per the
// theme overrides in `src/theme.tsx`: MuiInputBase / MuiTextField /
// MuiSelect / MuiAutocomplete all clamp to a single height per size variant).
export type FilterSize = 'small' | 'medium';

export const DEFAULT_FILTER_SIZE: FilterSize = 'small';
